import { render, staticRenderFns } from "./CollapsableList.vue?vue&type=template&id=16512593&scoped=true"
import script from "./CollapsableList.vue?vue&type=script&lang=js"
export * from "./CollapsableList.vue?vue&type=script&lang=js"
import style0 from "./CollapsableList.vue?vue&type=style&index=0&id=16512593&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16512593",
  null
  
)

export default component.exports